(ns kyber.kyber-db.current-user)

(def model
  {:ident-key :current-user/id
      
   :schema
   #:current-user
    {:id
     {:doc "Placeholder ID"}

     :current-user/curriculum-roles
     {:doc "User roles by curriculum"}
     
     :current-user/external-user-id
     {:doc ""}}})
